import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseComponent } from '../../../core/layout/components/abstracts/base.component';

@Component({
  selector: 'app-content-box',
  standalone: true,
  imports: [],
  templateUrl: './content-box.component.html',
  styleUrl: './content-box.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBoxComponent extends BaseComponent {

  @Input() padding = 'p-8';
  @Input() borderRadius: 'medium-border-radius' | 'base-border-radius' = 'medium-border-radius';
  @Input({ required: true }) theme: 'white' | 'gray' | 'orange' | 'blue';
  @Input() selected = false;
  @Input() withShadow = false;
}
